import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=447c4d21&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('447c4d21')) {
      api.createRecord('447c4d21', component.options)
    } else {
      api.reload('447c4d21', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=447c4d21&", function () {
      api.rerender('447c4d21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z7J6MtWY38WQ/JS/videoIframe.vue"
export default component.exports